export var BUTTON_SHAPE = {
  0: "round",
  1: "rectangle",
  2: "square"
};